import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ContactSEO } from '../components/SEO';
import { getUser } from '../services/api';
import { siteContent } from '../data/content';

export const ContactPage = () => {
  const user = getUser();
  const isAdmin = user?.is_admin || false;
  return (
    <div className="min-h-screen bg-off-white relative" data-testid="contact-page">
      <div 
        className="fixed inset-0 pointer-events-none z-0 opacity-[0.025] mix-blend-multiply"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,0,0,0.15) 1px, transparent 0)',
          backgroundSize: '20px 20px'
        }}
      />
      <div className="relative z-10">
        <ContactSEO />
        <Header isAdmin={isAdmin} />
        
        <section className="py-20 md:py-24 border-b border-black/10">
          <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-12">
            <h1 className="font-serif font-bold text-4xl md:text-5xl text-warm-black leading-tight mb-12">
              Contact for In-Person Meetings
            </h1>
            
            <div className="space-y-6 mb-16 font-sans text-base md:text-lg text-warm-black/70 leading-relaxed">
              <p>Faith by Experiments offers select in-person meetings for serious inquirers interested in deep discussion and collaborative experimentation.</p>
              <p>These are paid sessions for the people who wish to engage beyond written content.</p>
              <p>
                Prefer direct contact? Email us at{' '}
                <a href={`mailto:${siteContent.contact.email}`} className="text-accent-muted hover:text-accent-muted/80 font-medium underline">
                  {siteContent.contact.email}
                </a>
                .
              </p>
            </div>
            
          </div>
        </section>
        
        <Footer />
      </div>
    </div>
  );
};
